import { useFirestore, useFirestoreDocData } from 'reactfire'
import { useParams } from 'react-router-dom'
import { useState } from 'react'
import { theme, Typography } from 'antd'
import { doc, setDoc } from 'firebase/firestore'
import { errorResponse } from '../../lib/errorResponse'
import CompanyOperationsForm from '../Company/CompanyOperationsForm'
import { Trans } from 'react-i18next'

export function StepCompanyOperationsForm({
  onboarding,
  goToNext,
  goToPrevious,
}) {
  const data = onboarding?.company ?? {}

  const firestore = useFirestore()
  const { companyUid } = useParams()
  const [loading, setLoading] = useState(false)

  const { token } = theme.useToken()

  async function onSubmit(values) {
    setLoading(true)
    try {
      await setDoc(
        doc(firestore, 'onboarding', companyUid),
        { company: values },
        { merge: true }
      )
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  const { data: companiesConfigs } = useFirestoreDocData(
    doc(firestore, 'configs', 'companies')
  )

  return (
    <>
      <Typography.Paragraph style={{ marginBottom: token.marginLG }}>
        <Trans
          i18nKey="frontend:onboarding.companyOperationsIntro"
          components={{ strong: <strong /> }}
          values={{ name: onboarding.company.name }}
        />
      </Typography.Paragraph>
      <CompanyOperationsForm
        data={data}
        goBack={() => goToPrevious()}
        loading={loading}
        configs={companiesConfigs}
        requireNumberAndPin
        sendFormValues={onSubmit}
        showU1Levy
        showEstimator
      />
    </>
  )
}
